import { IAdvancedSearch } from '../types/interfaces';

class Api {
  API_OKPD2_URL = '/api/bitrix/api/v1/cpp/okpd2';

  // Раньше данные приходили с битрикса, сейчас перенесли на другой бэк
  // API_GET_OKPD2_URL = '/api/bitrix/api/v1/cpp/okpd2';

  API_GET_OKPD2_URL = '/api/okpd2';

  // API_REGIONS_URL = '/api/bitrix/api/v1/cpp/okato';

  API_GET_REGIONS_URL = '/api/okato';

  API_SUPPLIERS_SEARCH = '/api/bitrix/api/v1/cpp/suppliers_search';

  API_SUPPLIERS_SEARCH_STATUS = '/api/bitrix/api/v1/cpp/suppliers_search/';

  API_GET_SUPPLIERS_DATA = '/api/bitrix/api/v1/cpp/suppliers_search/';

  API_GET_SUPPLIERS_DATA_FOR_MODAL = '/api/bitrix/api/v1/cpp/contacts';

  API_GET_ETP_REGISTRATION = '/api/bitrix/api/v1/cpp/etp_registrations';

  API_GET_PURCHASE_HISTORY = '/api/bitrix/api/v1/cpp/bids';

  API_GET_PURCHASE_HISTORY_COMPLAINTS = 'api/bitrix/api/v1/cpp/complaints';

  API_GET_PURCHASE_HISTORY_CONTRACTS_AGGREGATES = 'api/bitrix/api/v1/cpp/contracts_aggregates';

  API_POST_GENERAL_REPORTS = '/api/general-reports';

  API_ETP_REPORT_TYPE = 'ETP_REGISTRATION';

  API_BID_REPORT_TYPE = 'BID';

  API_SUPPLIERS_SEARCH_REPORT_TYPE = 'SUPPLIERS_SEARCH';

  API_CHECKING_COUNTERPARTY_REPORT_TYPE = 'CHECKING_COUNTERPARTY';

  API_RNKIM_REPORT_TYPE = 'RNKIM';

  API_OFFERS_REQUEST_REPORT_TYPE = 'OFFERS_REQUEST';

  API_TRU_REPORT_TYPE = 'TRU';

  API_ZAKUPKI_ROSNEFT_REPORT_TYPE = 'ZAKUPKI_ROSNEFT';

  API_OKPD2_REPORT_TYPE = 'OKPD2';

  API_NMCK_REPORT_TYPE = 'NMCK';

  API_SKP_REPORT_TYPE = 'SKP';

  API_PURCHASES_DOCS_REPORT_TYPE = 'PURCHASES_DOCS';

  APi_GET_SELDON_TOKEN = '/api/seldon-token';

  API_GET_URL_IFRAME = '/api/persis-url?redirectUrl=';

  API_GET_COMPLAINANTS = '/api/bitrix/api/v1/cpp/complaints';

  API_GET_MENU_ITEMS = '/api/available-pages';

  API_GET_KUPEC_VIEW = '/api/auth/citc-iframe';

  API_GET_GARANT_TOKEN = '/api/auth/garant-token';

  // async getOkpd2Data() {
  //   const res = await fetch(this.API_OKPD2_URL);
  //   const result = await res.json();
  //   return result.payload.reduce((acc: { title: string; value: string }[], el: { code: string; name: string }) => {
  //     acc.push({ title: `${el.code} ${el.name}`, value: `${el.code} ${el.name}` });
  //     return acc;
  //   }, []);
  // }

  async getGarantToken() {
    return fetch(this.API_GET_GARANT_TOKEN, {
      method: 'POST',
      body: '',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
    });
  }

  async getKupecFrame(body?: any) {
    const res = await fetch(this.API_GET_KUPEC_VIEW, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body,
    });
    const result = await res.json();
    return result;
  }

  async getOkpd2Data(query?: any, amount?: any) {
    const url = `${this.API_GET_OKPD2_URL}?data=${encodeURIComponent(query)}&amount=${encodeURIComponent(amount)}`;
    const res = await fetch(url);
    const result = await res.json();

    return result?.reduce((acc: { title: string; value: string }[], el: { code: string; name: string }) => {
      acc.push({ title: `${el.code} ${el.name}`, value: `${el.code} ${el.name}` });
      return acc;
    }, []);
  }

  // async getRegionsData() {
  //   const res = await fetch(this.API_REGIONS_URL);
  //   const result = await res.json();
  //   return result.payload.reduce((acc: { title: string; value: string }[], el: { code: string; name: string }) => {
  //     acc.push({ title: `${el.code} ${el.name}`, value: `${el.code} ${el.name}` });
  //     return acc;
  //   }, []);
  // }

  async getOkatoRegionData(query?: any, amount?: any) {
    const url = `${this.API_GET_REGIONS_URL}?data=${encodeURIComponent(query)}&amount=${encodeURIComponent(amount)}`;
    const res = await fetch(url);
    const result = await res.json();

    return result?.reduce((acc: { title: string; value: string }[], el: { code: string; name: string }) => {
      acc.push({ title: `${el.code} ${el.name}`, value: `${el.code} ${el.name}` });
      return acc;
    }, []);
  }

  async startSuppliersSearch(options: IAdvancedSearch) {
    const res = await fetch(this.API_SUPPLIERS_SEARCH, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        ...options,
        okpd2_expansion_level: 0,
      }),
    });
    const body = await res.json();
    return body.payload.id;
  }

  async getSuppliersSearchStatus(searchID: number | null) {
    const res = await fetch(`${this.API_SUPPLIERS_SEARCH_STATUS}${searchID}`);
    const result = await res.json();
    return result.payload.status;
  }

  async getSuppliersData(searchID: number | null, page: number = 1) {
    const data = await fetch(`${this.API_GET_SUPPLIERS_DATA}${searchID}/results?page=${page}&per_page=10`);
    const body = await data.json();
    return body.payload;
  }

  async getSuppliersDataForModal(inn: string, kpp?: string) {
    const res = await fetch(`${this.API_GET_SUPPLIERS_DATA_FOR_MODAL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        organizations: [
          {
            inn,
            kpp,
          },
        ],
      }),
    });

    return res.json();
  }

  async getEtpRegistration(inn: string, kpp?: string) {
    const res = await fetch(this.API_GET_ETP_REGISTRATION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        organizations: [
          {
            inn,
            kpp,
          },
        ],
      }),
    });
    return res.json();
  }

  async getPurchaseHistory(inn: string, kpp: string, page: number, type?: string) {
    let buyerInn: string = '0000000000';
    let buyerKpp: string = '0000000000';

    const user = await fetch('/api/auth/me', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
      },
    });

    if (!type) {
      if (user.status < 300 && user.status >= 200) {
        const answer = await user.json();
        if (answer.ownerData.companyInn) {
          buyerInn = answer.ownerData.companyInn;
        }
        if (answer.ownerData.companyKpp) {
          buyerKpp = answer.ownerData.companyKpp;
        }
      }
    }

    const res = await fetch(`${this.API_GET_PURCHASE_HISTORY}?page=${page}&per_page=10'`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        inn,
        kpp,
        buyer_inn: buyerInn,
        buyer_kpp: buyerKpp,
      }),
    });
    const result = await res.json();
    if (!result.payload?.data) {
      return { error: result.payload };
    }
    return result.payload;
  }

  async getPurchaseHistoryContractsAggregates(inn: string) {
    const res = await fetch(`${this.API_GET_PURCHASE_HISTORY_CONTRACTS_AGGREGATES}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        organizations: [
          {
            inn,
          },
        ],
      }),
    });
    const result = await res.json();

    return result.payload;
  }

  async getPurchaseHistoryComplaints(inn: string, kpp?: string) {
    const res = await fetch(`${this.API_GET_PURCHASE_HISTORY_COMPLAINTS}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        inn,
        kpp,
      }),
    });
    const result = await res.json();
    return result.payload;
  }

  async getComplainants(inn: string, kpp?: string) {
    const res = await fetch(`${this.API_GET_COMPLAINANTS}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        inn,
        kpp,
      }),
    });
    const result = await res.json();
    return result;
  }

  async sendReport(type: string, data: any) {
    await fetch(this.API_POST_GENERAL_REPORTS, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        type,
        parameters: {
          ...data,
        },
      }),
    });
  }

  async getSeldonToken() {
    const res = await fetch(this.APi_GET_SELDON_TOKEN);
    return res.json();
  }

  async getUrlIframe(path: string) {
    const res = await fetch(`${this.API_GET_URL_IFRAME}${path}`);

    return res.json();
  }

  async getMenuItems() {
    const res = await fetch(`${this.API_GET_MENU_ITEMS}`);
    return res.json();
  }
}

const api = new Api();

export default api;
